var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTerScheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_1434)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_127_1434",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13931 0C5.93017 0 4.13931 1.79086 4.13931 4V20C4.13931 22.2091 5.93017 24 8.13931 24H13.6082L16.6393 27L19.6704 24H24.1393C26.3485 24 28.1393 22.2091 28.1393 20V4C28.1393 1.79086 26.3485 0 24.1393 0H8.13931Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13931 0C5.93017 0 4.13931 1.79086 4.13931 4V20C4.13931 22.2091 5.93017 24 8.13931 24H13.6082L16.6393 27L19.6704 24H24.1393C26.3485 24 28.1393 22.2091 28.1393 20V4C28.1393 1.79086 26.3485 0 24.1393 0H8.13931Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6082 24L15.0151 22.5785L14.4306 22H13.6082V24ZM16.6393 27L15.2324 28.4215L16.6393 29.814L18.0462 28.4215L16.6393 27ZM19.6704 24V22H18.848L18.2635 22.5785L19.6704 24ZM6.13931 4C6.13931 2.89543 7.03474 2 8.13931 2V-2C4.8256 -2 2.13931 0.686292 2.13931 4H6.13931ZM6.13931 20V4H2.13931V20H6.13931ZM8.13931 22C7.03474 22 6.13931 21.1046 6.13931 20H2.13931C2.13931 23.3137 4.8256 26 8.13931 26V22ZM13.6082 22H8.13931V26H13.6082V22ZM12.2013 25.4215L15.2324 28.4215L18.0462 25.5785L15.0151 22.5785L12.2013 25.4215ZM18.0462 28.4215L21.0773 25.4215L18.2635 22.5785L15.2324 25.5785L18.0462 28.4215ZM24.1393 22H19.6704V26H24.1393V22ZM26.1393 20C26.1393 21.1046 25.2439 22 24.1393 22V26C27.453 26 30.1393 23.3137 30.1393 20H26.1393ZM26.1393 4V20H30.1393V4H26.1393ZM24.1393 2C25.2439 2 26.1393 2.89543 26.1393 4H30.1393C30.1393 0.686292 27.453 -2 24.1393 -2V2ZM8.13931 2H24.1393V-2H8.13931V2Z",
    fill: "white",
    mask: "url(#path-2-inside-1_127_1434)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4649 16.2501L22.0214 6.75H19.1393L18.8238 16.2501H17.99L18.1563 11.2501H16.8064V9.08346L13.3063 11.2501V9.08346L9.63921 11.2501V16.2501H9.13931V17.4167H23.1393V16.2501H22.4649ZM12.306 14.5836H11.1394V13.417H12.306V14.5836ZM14.3059 14.5836H13.1393V13.417H14.3059V14.5836ZM16.306 14.5836H15.1394V13.417H16.306V14.5836Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_1434",
    x: 0.139313,
    y: 0,
    width: 32,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_1434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_1434",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTerScheme);
export default __webpack_public_path__ + "static/media/noTerScheme.9b39e018008cb80cc2af50b9fc1c3b5c.svg";
export { ForwardRef as ReactComponent };